import { errorMessage } from "../api/client";

export function InlineError({ error }: { error: unknown }) {
  if (!error) return null;
  return (
    <p role="alert" className="text-sm text-destructive">
      {errorMessage(error)}
    </p>
  );
}
